// src/mocks/data/verticals/beauty.js
// Demo dataset for business_type="beauty" (salon / beauty studio).

export const BUSINESS = {
  id: 1,
  name: "Glamour Studio",
  slug: "demo",
  business_type: "beauty",
  email: "contact@glamourstudio.ro",
  phone: "+40712345678",
  address: "Str. Florilor 12, Sector 1, București",
  country: "RO",
  currency: "RON",
  plan_code: "manager_pro",
  billing_cycle: "monthly",
  subscription_status: "active",
  current_period_end: "2026-12-31",
  grace_until: null,
  trial_used_at: "2026-01-01T10:00:00Z",
  trial_ends_at: null,
  stripe_customer_id: null,
  stripe_subscription_id: null,
  features: {
    appointments: true,
    clients: true,
    staff: true,
    services: true,
    stats: true,
    inventory: true,
    sms: false,
    sms_campaigns: false,
    chat: false,
  },
};

export const LOCATION = {
  id: 1,
  business: 1,
  name: "Glamour Studio – Floreasca",
  address: "Str. Florilor 12, Sector 1, București",
  phone: "+40712345678",
  email: "contact@glamourstudio.ro",
  timezone: "Europe/Bucharest",
  is_active: true,
};

export const WORKING_HOURS = {
  location_id: 1,
  timezone: "Europe/Bucharest",
  recurring: {
    "0": [{ start: "09:00", end: "17:00" }],
    "1": [{ start: "09:00", end: "17:00" }],
    "2": [{ start: "09:00", end: "17:00" }],
    "3": [{ start: "09:00", end: "17:00" }],
    "4": [{ start: "09:00", end: "17:00" }],
    "5": [],
    "6": [],
  },
};

export const BUSINESS_SETTINGS = {
  id: 1,
  name: "Glamour Studio",
  slug: "demo",
  email: "contact@glamourstudio.ro",
  phone: "+40712345678",
  address: "Str. Florilor 12, Sector 1, București",
  country: "RO",
  currency: "RON",
  timezone: "Europe/Bucharest",
  booking_buffer_minutes: 0,
  cancellation_policy: "Anularea programărilor se acceptă cu minimum 24h înainte.",
  logo: null,
};

export const CATEGORIES = [
  { id: 1, name: "Păr",    business: 1, sort_order: 1 },
  { id: 2, name: "Beauty", business: 1, sort_order: 2 },
];

export const SERVICES = [
  { id: 1, name: "Tuns + coafat",    duration: 45,  price: "80.00",  currency: "RON", category: "Păr", business: 1, is_active: true, color: "#FF6B6B", description: "" },
  { id: 2, name: "Vopsit păr",       duration: 90,  price: "180.00", currency: "RON", category: "Păr", business: 1, is_active: true, color: "#FF8E53", description: "" },
  { id: 3, name: "Balayage",         duration: 120, price: "280.00", currency: "RON", category: "Păr", business: 1, is_active: true, color: "#C0392B", description: "" },
  { id: 4, name: "Manichiură",       duration: 45,  price: "60.00",  currency: "RON", category: "Beauty", business: 1, is_active: true, color: "#9B59B6", description: "" },
  { id: 5, name: "Pedichiură",       duration: 60,  price: "70.00",  currency: "RON", category: "Beauty", business: 1, is_active: true, color: "#8E44AD", description: "" },
  { id: 6, name: "Tratament facial", duration: 60,  price: "100.00", currency: "RON", category: "Beauty", business: 1, is_active: true, color: "#3498DB", description: "" },
  { id: 7, name: "Extensii gene",    duration: 90,  price: "150.00", currency: "RON", category: "Beauty", business: 1, is_active: true, color: "#1ABC9C", description: "" },
  { id: 8, name: "Coafat mireasă",   duration: 120, price: "250.00", currency: "RON", category: "Păr", business: 1, is_active: true, color: "#F39C12", description: "" },
];

export const STAFF = [
  {
    id: 1,
    first_name: "Maria",
    last_name: "Ionescu",
    email: "maria@glamourstudio.ro",
    phone: "+40712200001",
    role: "owner",
    color: "#E74C3C",
    business: 1,
    location: 1,
    services: [1, 2, 3, 8],
    is_active: true,
    avatar: "https://i.pravatar.cc/150?img=12",
    bio: "Coafor cu 12 ani experiență, specializată în colorații complexe și tehnici moderne.",
  },
  {
    id: 2,
    first_name: "Ana",
    last_name: "Pop",
    email: "ana@glamourstudio.ro",
    phone: "+40712200002",
    role: "employee",
    color: "#3498DB",
    business: 1,
    location: 1,
    services: [5, 6, 7],
    is_active: true,
    avatar: "https://i.pravatar.cc/150?img=5",
    bio: "Estetician certificat, specializată în tratamente faciale și extensii gene.",
  },
  {
    id: 3,
    first_name: "Radu",
    last_name: "Constantin",
    email: "radu@glamourstudio.ro",
    phone: "+40712200003",
    role: "employee",
    color: "#2ECC71",
    business: 1,
    location: 1,
    services: [1, 2, 3],
    is_active: true,
    avatar: "https://i.pravatar.cc/150?img=51",
    bio: "Coafor senior, pasionat de tehnici de balayage și tăieri moderne.",
  },
  {
    id: 4,
    first_name: "Elena",
    last_name: "Dumitrescu",
    email: "elena@glamourstudio.ro",
    phone: "+40712200004",
    role: "employee",
    color: "#9B59B6",
    business: 1,
    location: 1,
    services: [4, 5, 7],
    is_active: true,
    avatar: "https://i.pravatar.cc/150?img=7",
    bio: "Specialist unghii și extensii gene, cu ochi pentru detaliu.",
  },
];

export const TIME_OFF = [
  {
    id: 1,
    staff: 2,
    staff_name: "Ana Pop",
    start_date: (() => { const d = new Date(); d.setDate(d.getDate() + 14); return d.toISOString().split("T")[0]; })(),
    end_date: (() => { const d = new Date(); d.setDate(d.getDate() + 17); return d.toISOString().split("T")[0]; })(),
    type: "vacation",
    notes: "Concediu anual",
    approved: true,
  },
];

export const CLIENTS = [
  { id: 1,  first_name: "Andreea",    last_name: "Ionescu",    phone: "+40712100001", email: "andreea.ionescu@email.ro",  notes: "Preferă produse fără sulfați", created_at: "2026-01-05T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=1"  },
  { id: 2,  first_name: "Elena",      last_name: "Popescu",    phone: "+40712100002", email: "elena.popescu@email.ro",    notes: "",                             created_at: "2026-01-08T11:00:00Z", avatar: "https://i.pravatar.cc/150?img=2"  },
  { id: 3,  first_name: "Maria",      last_name: "Constantin", phone: "+40712100003", email: "maria.c@email.ro",          notes: "Alergie la amoniac",           created_at: "2026-01-10T09:30:00Z", avatar: "https://i.pravatar.cc/150?img=3"  },
  { id: 4,  first_name: "Ioana",      last_name: "Dumitrescu", phone: "+40712100004", email: "ioana.d@email.ro",          notes: "",                             created_at: "2026-01-12T14:00:00Z", avatar: "https://i.pravatar.cc/150?img=4"  },
  { id: 5,  first_name: "Raluca",     last_name: "Gheorghe",   phone: "+40712100005", email: "raluca.g@email.ro",         notes: "Client VIP",                   created_at: "2026-01-15T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=6"  },
  { id: 6,  first_name: "Cristina",   last_name: "Stoica",     phone: "+40712100006", email: "",                          notes: "",                             created_at: "2026-01-20T11:00:00Z", avatar: "https://i.pravatar.cc/150?img=8"  },
  { id: 7,  first_name: "Diana",      last_name: "Marin",      phone: "+40712100007", email: "diana.marin@email.ro",      notes: "",                             created_at: "2026-01-22T09:00:00Z", avatar: "https://i.pravatar.cc/150?img=9"  },
  { id: 8,  first_name: "Alina",      last_name: "Popa",       phone: "+40712100008", email: "alina.popa@email.ro",       notes: "Preferă programări dimineața", created_at: "2026-01-25T10:30:00Z", avatar: "https://i.pravatar.cc/150?img=10" },
  { id: 9,  first_name: "Gabriela",   last_name: "Radu",       phone: "+40712100009", email: "",                          notes: "",                             created_at: "2026-01-28T13:00:00Z", avatar: "https://i.pravatar.cc/150?img=11" },
  { id: 10, first_name: "Mihaela",    last_name: "Lungu",      phone: "+40712100010", email: "mihaela.l@email.ro",        notes: "",                             created_at: "2026-02-01T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=13" },
  { id: 11, first_name: "Teodora",    last_name: "Nistor",     phone: "+40712100011", email: "teodora.n@email.ro",        notes: "Mireasă – nuntă în august",    created_at: "2026-02-03T11:00:00Z", avatar: "https://i.pravatar.cc/150?img=14" },
  { id: 12, first_name: "Roxana",     last_name: "Stan",       phone: "+40712100012", email: "",                          notes: "",                             created_at: "2026-02-05T14:00:00Z", avatar: "https://i.pravatar.cc/150?img=15" },
  { id: 13, first_name: "Lavinia",    last_name: "Bucur",      phone: "+40712100013", email: "lavinia.b@email.ro",        notes: "",                             created_at: "2026-02-08T09:00:00Z", avatar: "https://i.pravatar.cc/150?img=16" },
  { id: 14, first_name: "Simona",     last_name: "Tudor",      phone: "+40712100014", email: "simona.t@email.ro",         notes: "",                             created_at: "2026-02-10T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=17" },
  { id: 15, first_name: "Florentina", last_name: "Neagu",      phone: "+40712100015", email: "",                          notes: "",                             created_at: "2026-02-12T11:30:00Z", avatar: "https://i.pravatar.cc/150?img=18" },
  { id: 16, first_name: "Mădălina",   last_name: "Ciobanu",    phone: "+40712100016", email: "madalina.c@email.ro",       notes: "",                             created_at: "2026-02-15T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=19" },
  { id: 17, first_name: "Luminița",   last_name: "Vlad",       phone: "+40712100017", email: "",                          notes: "Nu trimite SMS",               created_at: "2026-02-18T14:00:00Z", avatar: "https://i.pravatar.cc/150?img=21" },
  { id: 18, first_name: "Camelia",    last_name: "Dinu",       phone: "+40712100018", email: "camelia.d@email.ro",        notes: "",                             created_at: "2026-02-20T09:00:00Z", avatar: "https://i.pravatar.cc/150?img=22" },
  { id: 19, first_name: "Nicoleta",   last_name: "Grigore",    phone: "+40712100019", email: "",                          notes: "",                             created_at: "2026-02-22T11:00:00Z", avatar: "https://i.pravatar.cc/150?img=23" },
  { id: 20, first_name: "Valentina",  last_name: "Anghel",     phone: "+40712100020", email: "valentina.a@email.ro",      notes: "Client din recomandare",       created_at: "2026-02-25T10:00:00Z", avatar: "https://i.pravatar.cc/150?img=24" },
];

let _id = 1;
function appt({ clientId, clientName, clientPhone, staffId, serviceId, serviceName, servicePrice, daysOffset, hour, minute = 0, duration, status, notes = "" }) {
  const start = new Date();
  start.setDate(start.getDate() + daysOffset);
  start.setHours(hour, minute, 0, 0);
  const end = new Date(start.getTime() + duration * 60 * 1000);
  const startIso = start.toISOString();
  const endIso = end.toISOString();
  return {
    id: _id++,
    client_id: clientId,
    client_name: clientName,
    client_phone: clientPhone,
    service_id: serviceId,
    service_name: serviceName,
    service_ids: [serviceId],
    service_names: [serviceName],
    service_price: servicePrice,
    employee: staffId,
    staff_id: staffId,
    staff_name: "",
    location: 1,
    start_time: startIso,
    end_time: endIso,
    start_at: startIso,
    end_at: endIso,
    status,
    notes,
  };
}

export const APPOINTMENTS = [
  appt({ clientId: 5,  clientName: "Raluca Gheorghe",    clientPhone: "+40712100005", staffId: 1, serviceId: 2, serviceName: "Vopsit păr",       servicePrice: 180, daysOffset: -13, hour: 10,  duration: 90,  status: "completed" }),
  appt({ clientId: 10, clientName: "Mihaela Lungu",      clientPhone: "+40712100010", staffId: 3, serviceId: 1, serviceName: "Tuns + coafat",    servicePrice: 80,  daysOffset: -12, hour: 9,   duration: 45,  status: "completed" }),
  appt({ clientId: 2,  clientName: "Elena Popescu",      clientPhone: "+40712100002", staffId: 4, serviceId: 7, serviceName: "Extensii gene",    servicePrice: 150, daysOffset: -11, hour: 11,  duration: 90,  status: "completed" }),
  appt({ clientId: 14, clientName: "Simona Tudor",       clientPhone: "+40712100014", staffId: 2, serviceId: 5, serviceName: "Pedichiură",       servicePrice: 70,  daysOffset: -10, hour: 14,  duration: 60,  status: "completed" }),
  appt({ clientId: 7,  clientName: "Diana Marin",        clientPhone: "+40712100007", staffId: 1, serviceId: 3, serviceName: "Balayage",         servicePrice: 280, daysOffset: -9,  hour: 10,  duration: 120, status: "completed" }),
  appt({ clientId: 16, clientName: "Mădălina Ciobanu",   clientPhone: "+40712100016", staffId: 3, serviceId: 1, serviceName: "Tuns + coafat",    servicePrice: 80,  daysOffset: -8,  hour: 9,   duration: 45,  status: "cancelled", notes: "Clienta a anulat cu 2h înainte" }),
  appt({ clientId: 8,  clientName: "Alina Popa",         clientPhone: "+40712100008", staffId: 4, serviceId: 4, serviceName: "Manichiură",       servicePrice: 60,  daysOffset: -7,  hour: 11,  duration: 45,  status: "completed" }),
  appt({ clientId: 11, clientName: "Teodora Nistor",     clientPhone: "+40712100011", staffId: 1, serviceId: 8, serviceName: "Coafat mireasă",   servicePrice: 250, daysOffset: -6,  hour: 9,   duration: 120, status: "completed", notes: "Probă coafură nuntă" }),
  appt({ clientId: 3,  clientName: "Maria Constantin",   clientPhone: "+40712100003", staffId: 2, serviceId: 6, serviceName: "Tratament facial", servicePrice: 100, daysOffset: -5,  hour: 14,  duration: 60,  status: "completed" }),
  appt({ clientId: 18, clientName: "Camelia Dinu",       clientPhone: "+40712100018", staffId: 3, serviceId: 2, serviceName: "Vopsit păr",       servicePrice: 180, daysOffset: -4,  hour: 10,  duration: 90,  status: "completed" }),
  appt({ clientId: 6,  clientName: "Cristina Stoica",    clientPhone: "+40712100006", staffId: 4, serviceId: 5, serviceName: "Pedichiură",       servicePrice: 70,  daysOffset: -3,  hour: 15,  duration: 60,  status: "no_show" }),
  appt({ clientId: 20, clientName: "Valentina Anghel",   clientPhone: "+40712100020", staffId: 1, serviceId: 1, serviceName: "Tuns + coafat",    servicePrice: 80,  daysOffset: -2,  hour: 11,  duration: 45,  status: "completed" }),
  appt({ clientId: 9,  clientName: "Gabriela Radu",      clientPhone: "+40712100009", staffId: 2, serviceId: 7, serviceName: "Extensii gene",    servicePrice: 150, daysOffset: -2,  hour: 14,  duration: 90,  status: "completed" }),
  appt({ clientId: 13, clientName: "Lavinia Bucur",      clientPhone: "+40712100013", staffId: 3, serviceId: 1, serviceName: "Tuns + coafat",    servicePrice: 80,  daysOffset: -1,  hour: 10,  duration: 45,  status: "completed" }),
  appt({ clientId: 4,  clientName: "Ioana Dumitrescu",   clientPhone: "+40712100004", staffId: 4, serviceId: 4, serviceName: "Manichiură",       servicePrice: 60,  daysOffset: -1,  hour: 14,  duration: 45,  status: "completed" }),

  appt({ clientId: 1,  clientName: "Andreea Ionescu",    clientPhone: "+40712100001", staffId: 1, serviceId: 1, serviceName: "Tuns + coafat",    servicePrice: 80,  daysOffset: 0,   hour: 9,   duration: 45,  status: "approved" }),
  appt({ clientId: 15, clientName: "Florentina Neagu",   clientPhone: "+40712100015", staffId: 3, serviceId: 3, serviceName: "Balayage",         servicePrice: 280, daysOffset: 0,   hour: 10,  duration: 120, status: "approved" }),
  appt({ clientId: 12, clientName: "Roxana Stan",        clientPhone: "+40712100012", staffId: 4, serviceId: 7, serviceName: "Extensii gene",    servicePrice: 150, daysOffset: 0,   hour: 11,  duration: 90,  status: "booked" }),
  appt({ clientId: 19, clientName: "Nicoleta Grigore",   clientPhone: "+40712100019", staffId: 2, serviceId: 6, serviceName: "Tratament facial", servicePrice: 100, daysOffset: 0,   hour: 13,  duration: 60,  status: "booked" }),
  appt({ clientId: 5,  clientName: "Raluca Gheorghe",    clientPhone: "+40712100005", staffId: 1, serviceId: 2, serviceName: "Vopsit păr",       servicePrice: 180, daysOffset: 0,   hour: 14,  duration: 90,  status: "booked" }),
  appt({ clientId: 17, clientName: "Luminița Vlad",      clientPhone: "+40712100017", staffId: 4, serviceId: 4, serviceName: "Manichiură",       servicePrice: 60,  daysOffset: 0,   hour: 16,  duration: 45,  status: "booked" }),

  appt({ clientId: 2,  clientName: "Elena Popescu",      clientPhone: "+40712100002", staffId: 1, serviceId: 1, serviceName: "Tuns + coafat",    servicePrice: 80,  daysOffset: 1,   hour: 10,  duration: 45,  status: "booked" }),
  appt({ clientId: 7,  clientName: "Diana Marin",        clientPhone: "+40712100007", staffId: 2, serviceId: 5, serviceName: "Pedichiură",       servicePrice: 70,  daysOffset: 1,   hour: 14,  duration: 60,  status: "booked" }),
  appt({ clientId: 11, clientName: "Teodora Nistor",     clientPhone: "+40712100011", staffId: 1, serviceId: 8, serviceName: "Coafat mireasă",   servicePrice: 250, daysOffset: 2,   hour: 9,   duration: 120, status: "approved", notes: "A doua probă – nuntă august" }),
  appt({ clientId: 8,  clientName: "Alina Popa",         clientPhone: "+40712100008", staffId: 3, serviceId: 2, serviceName: "Vopsit păr",       servicePrice: 180, daysOffset: 3,   hour: 11,  duration: 90,  status: "booked" }),
  appt({ clientId: 3,  clientName: "Maria Constantin",   clientPhone: "+40712100003", staffId: 4, serviceId: 4, serviceName: "Manichiură",       servicePrice: 60,  daysOffset: 4,   hour: 10,  duration: 45,  status: "booked" }),
  appt({ clientId: 10, clientName: "Mihaela Lungu",      clientPhone: "+40712100010", staffId: 1, serviceId: 3, serviceName: "Balayage",         servicePrice: 280, daysOffset: 5,   hour: 9,   duration: 120, status: "booked" }),
  appt({ clientId: 20, clientName: "Valentina Anghel",   clientPhone: "+40712100020", staffId: 2, serviceId: 7, serviceName: "Extensii gene",    servicePrice: 150, daysOffset: 6,   hour: 14,  duration: 90,  status: "booked" }),
  appt({ clientId: 14, clientName: "Simona Tudor",       clientPhone: "+40712100014", staffId: 3, serviceId: 1, serviceName: "Tuns + coafat",    servicePrice: 80,  daysOffset: 7,   hour: 10,  duration: 45,  status: "booked" }),
];

export const PRODUCTS = [
  { id: 1, name: "Vopsea L'Oréal Majirel 6.0",  sku: "LOR-001", category: "Vopsele",    unit: "tub",    price: "35.00",  business: 1, is_active: true },
  { id: 2, name: "Oxidant 20 Vol. Wella",         sku: "WEL-001", category: "Oxidanți",   unit: "flacon", price: "18.00",  business: 1, is_active: true },
  { id: 3, name: "Mască hidratantă Kerastase",    sku: "KER-001", category: "Tratamente", unit: "borcan", price: "120.00", business: 1, is_active: true },
  { id: 4, name: "Lac de unghii OPI – Roșu",     sku: "OPI-001", category: "Unghii",     unit: "flacon", price: "45.00",  business: 1, is_active: true },
  { id: 5, name: "Adeziv extensii gene",          sku: "GEN-001", category: "Gene",       unit: "flacon", price: "80.00",  business: 1, is_active: true },
  { id: 6, name: "Șampon profesional Redken",     sku: "RED-001", category: "Șampoane",   unit: "litru",  price: "55.00",  business: 1, is_active: true },
];

export const STOCK_LEVELS = [
  { product: 1, product_name: "Vopsea L'Oréal Majirel 6.0", location: 1, quantity: 24, min_quantity: 5 },
  { product: 2, product_name: "Oxidant 20 Vol. Wella",        location: 1, quantity: 12, min_quantity: 3 },
  { product: 3, product_name: "Mască hidratantă Kerastase",   location: 1, quantity: 6,  min_quantity: 2 },
  { product: 4, product_name: "Lac de unghii OPI – Roșu",    location: 1, quantity: 8,  min_quantity: 2 },
  { product: 5, product_name: "Adeziv extensii gene",         location: 1, quantity: 3,  min_quantity: 2 },
  { product: 6, product_name: "Șampon profesional Redken",    location: 1, quantity: 5,  min_quantity: 1 },
];

export const STOCK_MOVEMENTS = [
  { id: 1, product: 1, product_name: "Vopsea L'Oréal Majirel 6.0", type: "receive", quantity: 10, notes: "Comandă lunară",  created_at: "2026-03-15T10:00:00Z" },
  { id: 2, product: 6, product_name: "Șampon profesional Redken",   type: "receive", quantity: 5,  notes: "Reaprovizionare", created_at: "2026-03-18T11:00:00Z" },
  { id: 3, product: 2, product_name: "Oxidant 20 Vol. Wella",        type: "adjust",  quantity: -2, notes: "Pierderi",        created_at: "2026-03-20T09:30:00Z" },
];
